import {
  reactive
} from 'vue'

const headerContent = {
  title: "Engage every student through creativity",
  subTitle: "<a target='_blank' href='https://creator.eyejack.io' style='color:#e95557;'>EyeJack Edu</a> is the first AR technology built for Google Chrome and available for students of all ages to connect Art + Technology.",
  image: require("./assets/header-image.mp4"),
  button: {
    text: "Try it now!",
    url: "https://creator.eyejack.io",
  },
};

const features = {
  feature1: {
    title: "Learn",
    text: "Tutorials and activities are available to get you started in the classroom, including individual or group activities.",
    image: require("./assets/1.jpg"),
  },
  feature2: {
    title: "Play",
    text: "Used across all levels of education, from Primary to Secondary and Tertiary - it’s the perfect tool for any curriculum.",
    image: require("./assets/2.jpg"),
  },
  feature3: {
    title: "Create",
    text: "EyeJack Edu is easy to use for all students in Chrome on laptops and notebooks.",
    image: require("./assets/3.jpg"),
  },
};

const educators = {
  educator1: {
    name: "Tricia Clifford Fuglestad",
    profession: "K-5 Art Teacher. District 54, Illinois, USA ",
    testimony: '“EyeJack app is the perfect tool for showcasing our Transdigital (physical/digital) art. My students are absolutely WOWWED to see their work magically come to life!”',
    image: require("./assets/headshot1.png"),
  },
  educator2: {
    name: "Sacha Bryning",
    profession: "RMIT University, Melbourne Australia",
    testimony: '“The interface and walkthroughs make the steps in creating AR projects so simple you can get the students experimenting with their drawings from day 1.”',
    image: require("./assets/headshot2.png"),
  },
  educator3: {
    name: "David Rigg",
    profession: "St Aloysius College, Adelaide, Australia",
    testimony: '“Students of St Aloysius College used EyeJack to create the stunning and awarded AR murals that adorn Chancery Lane in Adelaide. Kudos to the EyeJack product, developed and supported in Australia.”',
    image: require("./assets/headshot3.png"),
  },
};

const resources = {
  step1: {
    title: "AR Animations",
    text: "List of helpful video tutorials on how EyeJack Creator can be used with different animation tools.",
    button: {
      text: "View",
      url: "https://eyejackapp.com/pages/ar-animations",
    },
    image: require("./assets/ej-gif.gif"),
    counter: 1,
  },
  step2: {
    title: "STEAM Ready",
    text: "Used across all levels of education, from Primary to Secondary and Tertiary, it’s the perfect tool for any Cirriculum.",
    button: "Download",
    image: require("./assets/placeholder.png"),
    counter: 2,
  },
  step3: {
    title: "Private and Secure",
    text: "Built with the Highest Standards for Privacy and Data Security, EyeJack is vigilant about student privacy.",
    button: "Download",
    image: require("./assets/placeholder.png"),
  },
};

const caseStudy = {
  case1: {
    coverTitle: "Student Exhibition",
    coverText: "Inspire students, teachers, parents and the community by creating AR exhibitions which showcase student work.",
    coverImage: require("./assets/tile-image.png"),
  },
  case2: {
    coverTitle: "Kites",
    coverText: "Colour in kite designs and see them lift off the page and fly up into the sky for you to control",
    coverImage: require("./assets/kites-cover-image.png"),
    title: 'Customise for your Classroom',
    text: 'Create new custom kite designs for your classroom and match it to your theme. Get your students engaged in this awesome interactive experience today.',
    button: 'Enquire Now',
    image: require('./assets/kites.png')
  },
};


const table = {
  head: [
    '<h2>ARTIST PLAN</h2>',
    '<h2>EDUCATION PLAN<h2>',
  ],
  bodyRegular: [
    [
      'Publish Artworks',
      require("./assets/tick.png"),
    
   
    ],
    [
      'Publish Collections',
      require("./assets/tick.png"),
   
    ],
    [
      'Publish Panels',
      require("./assets/tick.png"),
  
    ],
  ],
  bodyLight: [
    [
      '<span class="bold">10,000</span> Free Views per month<br /><span class="sub-views">($0.01 per View after 10,000)</span>',
      'Unlimited Views',
    ],
    [
      'Up to  <span class="bold">60</span> seconds per Artwork',
      require("./assets/tick.png"),
 
    ],
    [
      'Up to  <span class="bold">20</span> MB per Panel Project',
      require("./assets/tick.png"),
  
    ],
  ],
  price: [
    // '$10/month each<p class="card-price-p">(Pricing in $USD)</p></span>',
    // '<Button href="mailto:info+edu@eyejackapp.com">Enquire Now</Button>',
    '$10/month each<p class="card-price-p">(Pricing in $USD)</p></span>',
    'Enquire Now',
    

  ]
};

const download = {
  coverTitle: 'Try EyeJack Edu in Chrome for yourself!',
  button: 'Find out more',
  link: "https://creator.eyejack.io"
}

const clients = [{
    logo: require('./assets/client-1.png'),
    url: '1'
  },
  {
    logo: require('./assets/client-2.png'),
    url: '2'
  },
  {
    logo: require('./assets/client-3.png'),
    url: '3'
  },
  {
    logo: require('./assets/client-4.png'),
    url: '4'
  },
  {
    logo: require('./assets/client-5.png'),
    url: '5'
  },
  {
    logo: require('./assets/client-6.png'),
    url: '6'
  },
  {
    logo: require('./assets/client-7.png'),
    url: '7'
  },
  {
    logo: require('./assets/client-8.png'),
    url: '8'
  },
  {
    logo: require('./assets/client-9.png'),
    url: '9'
  },
  {
    logo: require('./assets/client-10.png'),
    url: '10'
  },
]

const faqs = [{
    question: "How does EyeJack creator work?",
    answer: "EyeJack Creator is a simple desktop app that lets artists bring their art to life with animations and sound with three simple steps...<br>1) Upload your art.<br>2) Upload your animation.<br>3) Test your new AR art with the EyeJack mobile app.",
    open: false,
  },
  {
    question: "How can I add an animation?",
    answer: "EyeJack Creator supports videos, animated gifs or png sequences. You could create a video using your smartphone OR if you want to try something more advanced, we recommend using programs like Adobe Photoshop, Animate or After Effects to create animations. Here are some additional resources to help you start animating in AR.",
    open: false,
  },
  {
    question: "Can I do animation with transparency?",
    answer: "Yes you can import your animation into EyeJack Creator as a transparent PNG sequence or a transparent GIF and it will show as transparent in AR!",
    open: false,
  },
  {
    question: "How long should an AR animation be?",
    answer: "We find that 30 seconds is a good amount of length for an AR animation. If you require your animation to be longer, an animation can be up to 60 seconds in length on the Artist plan and up to 120 seconds in length on the Virtuoso plan.",
    open: false,
  },
  {
    question: "Will my artwork always be available?",
    answer: "Once you create an Artwork, the educator will advise how long the artwork will be available and if they secure a license to extend availability. This is something that is controlled by the educator and the school.",
    open: false,
  },
  {
    question: "How can I create an animation?",
    answer: "<span class='italic'>EyeJack Creator</span> supports videos, animated gifs or png sequences. You could create a video using your smartphone OR if you want to try something more advanced, we recommend using programs like Adobe Photoshop, Animate or After Effects to create animations. Here is a 1 minute Photoshop animation tutorial to teach you <a target='_blank' href='https://www.youtube.com/watch?v=omdfcGYEqPY&ab_channel=AdobeCreativeCloud' class='faq-link'>how to create a simple gif animation</a>.<br><br><span class='italic'>*The advantage of a gif animation or a png sequence is it lets you export your animation with a transparent background. Show sample of animation with transparent background.</span>",
    open: false,
  },
  {
    question: "My AR animation is glitchy - any tips?",
    answer: "Augmented Reality works best with artwork that contains the following features:<br>- good contrast<br>- rich in detail<br>- avoid symmetry<br>- avoid repetitive patterns<br>- symmetry and patterns can also confuse the AR image recognition technology",
    open: false,
  },
]

const store = reactive({
  headerContent,
  features,
  educators,
  resources,
  caseStudy,
  download,
  table,
  clients,
  faqs
})

export default store;